import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DatePickerNoTimeZone } from '@platform/base';
import CompMeta from '../../meta/LowCodeComponents/DateTimePicker';
/**
 * @class DatePickerNoTimeZone
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.DatePickerNoTimeZone
 * @label 日期无时区
 *
 */
class NCDatePickerNoTimeZone extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
        * @title 区域编码
        * @description 组件标识
        */
        moduleId: PropTypes.string.isRequired,
        /**
        * @title 显示必填标识
        * @description 显示必填标识
        */
        showStar: PropTypes.bool,
        /**
         * @title className
         * @description 样式
         */
        className: PropTypes.string,
        /**
         * @title 自动化Id
         * @description 自动化Id
         */
        fieldid: PropTypes.string,
        /**
         * @title 禁用
         * @description 禁用
         */
        disabled: PropTypes.bool,
        /**
        * @title 自动聚焦
        * @description 自动聚焦
        */
        autoFocus: PropTypes.bool,
        /**
       * @title 预置文字
       * @description 预置文字
       */
        placeholder: PropTypes.string
    }
    static getCompMeta = () => {
        return CompMeta;
    }

    static defaultProps = {
        disabled: false
    }

    render() {
        return (
            <DatePickerNoTimeZone {...this.props} />
        )
    }
}

export default NCDatePickerNoTimeZone;
